<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <Header/>
        <b-container fluid>

            <b-row class="titulo">
                <b-col class="seccionTitulo">
                    <span class="fa fa-table"></span>
                    <span>Permisos</span>
                </b-col>
                <b-col class="seccionCodigo">
                    <div>C-00</div>
                </b-col>
            </b-row>

            <b-row>
                <b-col class="subtitulos">
                    Búsqueda de permisos
                </b-col>
            </b-row>

            <b-row>
                <b-col>

                    <b-row align-v="center" align-h="end">
                        <b-col>

                            <b-form-group align="left">
                                <label for="nombreBusq">Palabra clave</label>
                                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="menu-button-wide"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input name="nombre" placeholder="Nombre del permiso"
                                                  v-model="filtro.palabraClave" @keydown.enter.native="obtener"
                                    ></b-form-input>
                                </b-input-group>
                            </b-form-group>

                        </b-col>

                        <b-col></b-col>

                        <b-col align="right">
                            <b-button v-b-tooltip.hover title="Agregar permiso" variant="outline-success"
                                      @click="agregar()" v-if="$localStorageService.can('BO_02_alta_permiso')">Agregar permiso
                            </b-button>
                        </b-col>

                    </b-row>

                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12">
                    <b-table
                            id="Pendientes"
                            thead-tr-class="columnas"
                            :items="datosTabla"
                            :fields="fields"
                            :per-page="$registrosPorPaginaTabla"
                            :current-page="paginaActual"
                            responsive="true"
                            class="parrafos"
                            fixed>
                            <template v-slot:cell(permiso)="row">
                                <p style="text-transform: none !important;">{{ row.item.permiso }}</p>
                            </template>
                            <template v-slot:cell(descripcion)="row">
                                <p style="text-transform: none !important;">{{ row.item.descripcion }}</p>
                            </template>
                            <template v-slot:cell(fechaModificacion)="row">
                                {{ row.item.fechaModificacion | formatoFechaCorta }}
                            </template>
                        <template v-slot:cell(Acciones)="row">
                            <b-button-group>
                                <b-button v-if="$localStorageService.can('BO_02_modif_permiso')"
                                        title="Modificar permiso"
                                        size="sm"
                                        @click="modificar(row.item)"
                                        variant="outline-warning"
                                ><em class="fa fa-pencil"></em></b-button>
                                <b-button v-if="!row.item.registroActivo && $localStorageService.can('BO_02_activar_permiso')"
                                          title="Activar permiso"
                                          variant="outline-danger"
                                          size="sm"
                                          @click="activar(row.item)"
                                ><em class="fa fa-undo"></em></b-button>
                                <b-button v-else-if="$localStorageService.can('BO_02_baja_permiso')"
                                          title="Desactivar permiso"
                                          variant="outline-danger"
                                          size="sm"
                                          @click="desactivar(row.item)"
                                >
                                    <b-icon icon="trash-fill"></b-icon>
                                </b-button>
                            </b-button-group>

                        </template>
                    </b-table>
                    <div align="center" v-if="loader">
                        <b-spinner variant="primary" label="Spinning"></b-spinner>
                    </div>
                    <b-col v-if="!loader">
                        <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
                    </b-col>
                    <b-col v-if="!loader">
                        <b-pagination
                                v-if="datosTabla !== undefined && datosTabla.length > 10"
                                align="center"
                                v-model="paginaActual"
                                :total-rows="datosTabla.length"
                                :per-page="$registrosPorPaginaTabla"
                                aria-controls="my-table1"
                        ></b-pagination>
                    </b-col>
                </b-col>


            </b-row>

        </b-container>


        <b-modal
                v-model="show"
                :title="tituloModal"
                size="lg"
                scrollable
        >
            <b-form @submit.stop.prevent="guardar">
                <b-container fluid>
                    <b-row>
                        <b-col>

                            <b-form-group align="left">
                                <label for="nombre">Nombre
                                    <validacion />
                                </label>
                                <b-input-group size="sm" class="mb-2" id="nombre">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="menu-button-wide"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input name="nombre" placeholder="Nombre del permiso"
                                                  v-model="$v.permiso.permiso.$model"
                                                  :state="validateState('permiso')"
                                                  style="text-transform: none !important;"
                                    ></b-form-input>
                                </b-input-group>

                            </b-form-group>

                        </b-col>

                        <b-col>
                            <b-form-group align="left">
                                <label for="descripcion">Descripción</label>
                                <b-input-group size="sm" class="mb-2" id="nombre">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="menu-button-wide"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-textarea name="descripcion" placeholder="Nombre del permiso"
                                                     v-model="$v.permiso.descripcion.$model"
                                                     :state="validateState('descripcion')"
                                                     rows="3"
                                                     max-rows="6"
                                                     style="text-transform: none !important;"
                                    ></b-form-textarea>
                                </b-input-group>

                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-container>
                <b-button ref="submitGuardar" type="submit" style="visibility: hidden"></b-button>
            </b-form>

            <template v-slot:modal-footer>
                <b-button variant="outline-primary" @click="submitGuardar" :disabled="loaderAcciones">
                    <span v-if="!loaderAcciones">Guardar</span>
                    <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                        Cargando...
                    </span>
                </b-button>
                <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
            </template>

        </b-modal>
    </div>
</template>

<script>
    import Header from "../../components/Header";
    import {validationMixin} from "vuelidate";
    import {required} from "vuelidate/lib/validators";


    export default {
        name: "permisoIndex",
        components: {
            Header
        },
        mixins: [validationMixin],
        data: () => {
            return {
              version: process.env.VUE_APP_ENV_VERSION,
              debug: false,
                datosTabla: [],
                fields: [
                    {key: "idPermiso", label: "ID", sortable: true},
                    {key: "permiso", label: "Nombre", sortable: true},
                    {key: "descripcion", label: "Descripción", sortable: false},
                    {key: "fechaModificacion", label: "Fecha modificación", sortable: true},
                    {key: "nombreUsuarioModificacion", label: "Usuario modificación", sortable: true},
                    "Acciones",
                ],
                paginaActual: 1,
                show: false,
                tituloModal: '',
                permiso: {
                    idPermiso: null,
                    permiso: null,
                    descripcion: null
                },
                filtro: {
                    id: null,
                    palabraClave: null,
                    registroActivo: null
                },
                loaderAcciones: false,
                loader: false,
            }
        },
        validations: {
            permiso: {
                permiso: {required},
                descripcion: {}
            }
        },
        created() {
          this.debug = this.$localStorageService.getDebug();
            this.obtener();
        },
        methods: {
            obtener() {
                this.loader = true;
                this.datosTabla = [];
                this.$http.post(this.$api + 'catalogos/permisos/obtenerPermisos', this.filtro).then(respuesta => {
                        if (respuesta.data.data) {
                            respuesta.data.data.forEach(it => {
                                this.paginaActual=1;
                                this.datosTabla.push(it);
                            })
                        }

                    }
                ).finally(() => {
                        this.loader = false;
                    }
                )
            },
            agregar() {
                this.$nextTick(() => {
                    this.$v.$reset()
                });
                this.permiso = {
                    dPermiso: null,
                    permiso: null,
                    descripcion: null
                };
                this.tituloModal = 'Agregar permiso';
                this.show = true;
            },
            modificar(item) {
                this.$nextTick(() => {
                    this.$v.$reset()
                });
                this.permiso = JSON.parse(JSON.stringify(item));
                this.tituloModal = 'Modificar permiso';
                this.show = true;
            },
            submitGuardar() {
                this.$refs.submitGuardar.click();
            },
            guardar() {
                this.$v.permiso.$touch();
                if (this.$v.permiso.$anyError) {
                    return;
                }
                if (!this.$v.permiso.$invalid) {
                    this.loaderAcciones = true;
                    this.$http.post(this.$api + 'catalogos/permisos/guardar', this.permiso).then(respuesta => {
                            if (respuesta.data.data) {
                                this.$swal.fire({
                                    icon: "info",
                                    title: "Aviso",
                                    text: "El permiso se registró correctamente",
                                });
                                this.filtro.palabraClave = this.permiso.permiso;
                                this.obtener();
                                this.show = false;
                            }
                        }
                    ).catch(error => {
                        console.error(error);
                        this.$swal.fire({
                            icon: "error",
                            title: "Aviso",
                            text: "El permiso ya existe",
                        });
                    }).finally(() => {
                            this.loaderAcciones = false;
                        }
                    )
                }
            },
            activar(item) {
                this.$swal({
                    icon: "warning",
                    text: "¿Está seguro de activar el permiso?",
                    confirmButtonText: 'Si',
                    cancelButtonText: 'No',
                    showCancelButton: true,
                    showConfirmButton: true,
                }).then((aceptar) => {
                    if (aceptar.value) {
                      const parametros = {
                        idPermiso : item.idPermiso
                      }
                        this.$http.post(this.$api + 'catalogos/permisos/activar', parametros).then(respuesta => {
                                if (respuesta.data.data) {
                                    this.datosTabla[this.datosTabla.indexOf(item)].registroActivo = true;
                                }
                            }
                        )
                    }
                })
            },
            desactivar(item) {
                this.$swal({
                    icon: "warning",
                    text: "¿Está seguro de desactivar el permiso?",
                    confirmButtonText: 'Si',
                    cancelButtonText: 'No',
                    showCancelButton: true,
                    showConfirmButton: true,
                }).then((aceptar) => {
                    if (aceptar.value) {
                        const params = {
                            idPermiso: item.idPermiso
                        }
                        this.$http.post(this.$api + 'catalogos/permisos/desactivar', params).then(respuesta => {
                                if (respuesta.data.data) {
                                    this.datosTabla[this.datosTabla.indexOf(item)].registroActivo = false;
                                }
                            }
                        )
                    }
                })
            },
            validateState(name) {
                const {$dirty, $error} = this.$v.permiso[name];
                return $dirty ? !$error : null;
            },
            cerrarModal() {
                this.show = false;
            }
        }
    }
</script>

<style scoped>

</style>
